<div class="flex-column fullheight-noscroll" style="max-width: 650px;">
	<h2 class="modal-title">
		{{ "ORDER.CHANGE_DIALOG.TITLE" | trans : order.title }}
	</h2>

	<div style="overflow: auto">
		<div class="field-grid" form-collector #orderForm="collector">
			<label class="input outlined" title="{{ 'ORDER.TITLE' | trans }}">
				<i icon="ballot"></i>
				<input [(ngModel)]="order.title" placeholder="{{ 'ORDER.TITLE' | trans }}"
				conditions="nonempty" />
			</label>

			<task-whier-picker required
					[(ngModel)]="order.whier"
					[requiredLevel]="3"
					[maxLevel]="3">
			</task-whier-picker>

			<label class="input outlined" title="{{ 'ORDER.INVESTMENT_TYPE' | trans }}">
				<select [(ngModel)]="order.investment_type" required>
					<option *ngFor="let type of investment_types | keyvalue" [ngValue]="+type.key">
							{{ ("ORDER.INVESTMENT_TYPE." + type.value) | trans }}
					</option>
				</select>
			</label>
		</div>

		@if (can_edit_inventory){
			<task-inventory-cards 
				[disabled]="false" 
				[(ngModel)]="new_inventory" 
				(ngModelChange)="new_inventory=$event;"
				[location_cin]="order.location_cin" 
				[in_grid]="false">
			</task-inventory-cards>
		}

		<div class="flex-row align-center wrappable" style="margin-top: 1em; max-width: 650px;" *ngIf="order_flags.length > 0">
			<label class="checkbox-input" style="margin: 0;">
				<input 
					type="checkbox" 
					[(ngModel)]="order.insurance" 
					[disabled]="order.insurance_unchecked_reason"
				/>
				<span [style.opacity]="order.insurance_unchecked_reason  ? 0.7 : 1">{{"ORDER.INSURANCE" | trans}}</span>
				@if (order.insurance_unchecked_reason) {
					<span style="color: rgba(var(--fng-color))">*</span>
				}
		  </label>
			
			<ng-container *ngFor="let flag of order_flags">
				<label class="checkbox-input">
					<input 
						type="checkbox" 
						[(ngModel)]="flag.selected" 
						(ngModelChange)="on_label_flag_change(flag)" 
					/>
					<span>{{flag.name}}</span>
				</label>
			</ng-container>
		</div>

		@if (order.insurance_unchecked_reason) {
			<div class="grid-card flex-column" style=" margin-top: 1.75rem; min-height: auto;">
				 <div class="display: flex; align-items: center;">
					  <h3 class="card-header-title">
							<strong style="color: rgba(var(--fng-color)); font-size: 0.9em;">* </strong>
							{{'ORDER.INSURANCE_UNCHECKED_LABEL' | trans}}, 
							<span style="font-size: 0.9em;">{{order.insurance_unchecked_date | datefmt : 'short_date': false}}</span>
					  </h3>
							
					  
				 </div>
				 
				 <div class="display: flex; align-items: center;">
					  <strong>{{order.insurance_unchecked_by}}:  </strong>
					  <span>{{ order.insurance_unchecked_reason }}</span>
				 </div>

			</div>
	  }
	</div>

	<div class="flex-row modal-footer">

		<button color="primary" (click)="cancel()">
			<i icon="clear"></i>
			{{ 'CANCEL' | trans }}
		</button>

		<button class="filled" color="secondary" (click)="done()" [disabled]="orderForm.containsErrors()">
			<i icon="check"></i>
			{{ 'SAVE' | trans }}
		</button>

	</div>
</div>
